export default "__VITE_ASSET__eb5e8567__"